import type { TokenInfo } from "./exchangeRate";

const tokenList = [
  {
    address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    symbol: "USDT",
    decimals: 6,
  },
  {
    address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    symbol: "USDC",
    decimals: 6,
  },
  {
    address: "9vMJfxuKxXBoEa7rM12mYLMwTacLMLDJqHozw96WQL8i",
    symbol: "UST",
    decimals: 6,
  },
  {
    address: "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
    symbol: "PAI",
    decimals: 6,
  },
  {
    address: "USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX",
    symbol: "USDH",
    decimals: 6,
  },
  {
    address: "3RudPTAkfcq9Q9Jk8SVeCoecCBmdKMj6q5smsWzxqtqZ",
    symbol: "pUSDT",
    decimals: 6,
  },
  {
    address: "FgSsGV8GByPaMERxeQJPvZRZHf7zCBhrdYtztKorJS58",
    symbol: "pUSDC",
    decimals: 6,
  },
  {
    address: "Gcu9zjxrjez4xWGj8bi2gTLXYN8hD8Avu2tN8xfnV65Q",
    symbol: "CUSD",
    decimals: 8,
  },
  {
    address: "GHStiPQDe4HEQxtDzyFFuNjP6Z6GqYhbPqJ6oiRFmGWT",
    symbol: "CUSDC",
    decimals: 8,
  },
  {
    address: "1msZrgEMrhEzhLWjGvEpqo3RUuzMWGs4x9S6j3Nk1hK",
    symbol: "CSOL",
    decimals: 8,
  },
  {
    address: "32JXVurQacMxQF6qFxKkeAbysQcXsCakuYx3eyYRBoSR",
    symbol: "COFF",
    decimals: 6,
  },
];

export class ConstTokenProvider {
  async tokens(): Promise<Array<TokenInfo>> {
    return new Promise((resolve, reject) => {
      resolve(tokenList);
      reject("unkown error");
    });
  }
}
